/* eslint-disable react/prop-types */

import React from 'react';
import { MdEdit, MdOutlineAddBox, MdDelete } from 'react-icons/md';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IoMdAdd } from 'react-icons/io';
import { BsThreeDotsVertical } from 'react-icons/bs';

const ActionColumn = ({
  row,
  handleAction,
  cellProps,
  traceability = false
}) => {
  // Define the actions configuration dynamically
  const actionsConfig = [
    {
      condition: row.original.action?.edit === true,
      label: 'Edit',
      icon: <MdEdit />,
      onClick: () => handleAction('edit', row.original)
    },
    {
      condition: row.original.action?.view === true,
      label: 'View Map',
      icon: <MdEdit />,
      onClick: () => handleAction('view', row.original)
    },
    {
      condition: row.original.action?.add_farmland === true,
      label: 'Add Farmland',
      icon: <IoMdAdd />,
      onClick: () => handleAction('add', row.original)
    },
    {
      condition: row.original.action?.add_cultivation === true,
      label: 'Add Cultivation',
      icon: <IoMdAdd />,
      onClick: () => handleAction('add', row.original)
    },
    {
      condition: row.original.action?.update_harvest === true,
      label: 'Update actual Harvest',
      onClick: () => handleAction('add', row.original)
    },
    {
      condition:
        row.original.action?.verify === true &&
        row.original.Operator !== 'Verified',
      label: 'Verify',
      onClick: () => handleAction('verify', row.original)
    },
    {
      condition: row.original.action?.delete === true,
      label: 'Delete',
      icon: <MdDelete />,
      onClick: () => handleAction('delete', row.original)
    },
    {
      condition: row.original.action?.download === true,
      label: 'Download',
      onClick: () => handleAction('download', row.original)
    },
    {
      condition: row.original.action?.viewData === true,
      key: 'viewData',
      label: 'View',
      onClick: () => handleAction('viewData', row.original)
    },
    {
      condition: row.original.action?.view_details === true,
      key: 'viewData',
      label: 'View',
      onClick: () => handleAction('viewDetails', row.original)
    }
  ];

  // Filter actions that are allowed (where the condition is true)
  const allowedActions = actionsConfig.filter(action => action.condition);

  // If there are more than two actions, use a dropdown
  // Extract key from cellProps if provided
  const { key, ...restCellProps } = cellProps || {};

  return (
    <td {...restCellProps}>
      {Object.values(row.original.action).every(
        value => value === false
      ) ? null : Object.keys(row?.original?.action).length >
        (traceability ? 0 : 2) ? (
        <Dropdown align="end">
          <Dropdown.Toggle variant="link" size="md" style={{ padding: 0 }}>
            {traceability ? (
              <BsThreeDotsVertical className="fs--1 p-0" />
            ) : (
              <FontAwesomeIcon icon={'ellipsis-h'} className="fs--1 p-0" />
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu className="border">
            {allowedActions.map((action, index) => (
              <Dropdown.Item key={index} onClick={action.onClick}>
                {action.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <div className="d-flex overflow-hidden gap-2">
          {allowedActions.map((action, index) => (
            <button
              key={index}
              className="btn btn-outline-primary flex-shrink-0 btn-sm"
              onClick={action.onClick}
              title={action.label}
            >
              {action.icon || action.label}
            </button>
          ))}
        </div>
      )}
    </td>
  );
};

export default ActionColumn;
